<template>
  <div class="requisition-documents-container mb-4">
    <div class="mb-3">
      <section-title
        class="pt-2"
        content="Documentos que Sustentan la Requisición"
      />
    </div>
    <div v-if="hasDocuments">
      <div
        v-for="(item, key) in item.referralDocuments"
        :key="key"
        class="p-3 my-3 bg-secondary-3  rounded border-left-2"
      >
        <div class="row d-flex align-items-center px-3 ">
          <div class="col-md-5 col-sm-12">
            <div class="color-secondary-6 font-14">
              Nombre del Documento:
            </div>
            <div>
              {{ item.title | empty }}
            </div>
          </div>
          <div class="col-md-5 col-sm-12">
            <div class="color-secondary-6 font-14">
              Archivo:
            </div>
            <div>
              {{ item.fileName | empty }}
            </div>
          </div>
          <div class="col-md col-sm-12 d-flex justify-content-end">
            <action-button
              variant="success"
              class="text-white"
              i="fa fa-file-download"
              @click="handlerDownloadDocument(item)"
            />
          </div>
        </div>
      </div>
    </div>
    <custom-result-not-found
      v-else
      text="No hay documentos que sustentan la requisición"
    />
  </div>
</template>

<script>
import ActionButton from 'ActionButton';
import SectionTitle from 'SectionTitle';
import CustomResultNotFound from 'custom-result-not-found';

import referralService from '@/services/api/referralsandequipments.api';
import documentsService from '@/services/api/document.api';

export default {
  name: 'RequisitionSupportingDocuments',
  components: {
    ActionButton,
    SectionTitle,
    CustomResultNotFound,
  },
  props: {
    item: {
      type: Object,
      required: true,
    },
  },
  computed: {
    id() {
      return this.item.id;
    },
    hasDocuments() {
      return Boolean(this.item.referralDocuments.length);
    },
  },
  async mounted() {
    await this.getDocuments();
  },
  methods: {
    async getDocuments() {
      if (this.hasDocuments) return;
      const { data } = await referralService.getRequisitionsDocuments(this.id);
      this.item.referralDocuments = data;
    },
    async handlerDownloadDocument(document) {
      await documentsService.downloadatdocument(
        document.id,
        document.peiAtServiceId,
        document.documentTypeId
      );
    },
  },
};
</script>
<style lang="scss" scoped>
.requisition-documents-container i.fas.fa-file {
  height: 30px;
  width: 30px;
}
.border-left-2 {
  border-left-style: solid;
  border-left-width: 4px;
  border-left-color: #d9e5df;
}
</style>
